import { render, staticRenderFns } from "./WebPartImageSetting.vue?vue&type=template&id=1268f996&"
import script from "./WebPartImageSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartImageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1268f996')) {
      api.createRecord('1268f996', component.options)
    } else {
      api.reload('1268f996', component.options)
    }
    module.hot.accept("./WebPartImageSetting.vue?vue&type=template&id=1268f996&", function () {
      api.rerender('1268f996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartImageSetting.vue"
export default component.exports